import React, { useRef, useState } from "react"

import TextInput from "@/pages/Attendance/Chat/ConversationPanel/Input/TextInput"
import { ButtonMessageData } from "@/protocols/channel"
import { Grid, IconButton, InputAdornment, InputLabel, MenuItem, Select } from "@material-ui/core"
import {
	Close as CloseIcon
} from "@material-ui/icons"
import VariableInput, { Variable } from "@/components/ChatMessageBuilder/VariableInput"
import { TextEditor } from "@/components"
import { TextEditorInputHandler } from "@/components/TextEditor"
import { hasVariable } from "@/utils/message"
import { Text, themeColors } from "letalkui"

import ManageTemplateButtonsFormURLTipsPopover from "@/pages/Admin/Templates/ManageTemplateForm/ManageTemplateButtonsForm/ManageTemplateButtonsFormURLTipsPopover"
import { ValidationType } from "@/hooks/useValidation"

type ManageTemplateURLButtonProps = {
	index: number
	button: ButtonMessageData
	handleButtonTextChange: (text: string, index: number) => void
	handleRemoveButtons: (index: number) => void
	handleChangeButtonURL: (url: string, index: number) => void
	variables: Variable[]
	validation?: ValidationType
}

type URLTypeOption = "static" | "dynamic"

const TEMPLATE_BUTTON_URL_TYPE_OPTIONS_TO_READABLE_OPTION: Record<URLTypeOption, string> = {
	static: "Estática",
	dynamic: "Dinâmica"
}

const ManageTemplateURLButton: React.FC<ManageTemplateURLButtonProps> = (props) => {
	const { button, index, validation, variables, handleButtonTextChange, handleRemoveButtons, handleChangeButtonURL } = props

	const [selectedURLType, setSelectedURLType] = useState<URLTypeOption>("static")
	const editorRef = useRef<TextEditorInputHandler>(null)

	const handleURLTypeChange = (newType: URLTypeOption) => {
		setSelectedURLType(newType)
		handleChangeButtonURL("", index)
	}

	return (
		<Grid item xs={12}>
			<Grid container alignItems="flex-start" direction="row" spacing={2} xs={12}>
				<Grid item xs={6}>
					<Grid container direction="column">
						<Grid item>
							<TextInput
								placeholder="Título do botão"
								defaultValue={button?.text}
								inputProps={{ maxLength: 25 }}
								isOutlined
								onMedia={() => ""}
								onSubmit={() => ""}
								onChange={(value) => handleButtonTextChange(value ?? "", index)}
							/>
						</Grid>
						{!!validation?.[`buttons[${index}].text`] && (
							<Grid item>
								<Text.Body
									type="smaller2"
									color={themeColors.getTextErrorColor()}
								>
									{validation[`buttons[${index}].text`]}
								</Text.Body>
							</Grid>
						)}
					</Grid>
				</Grid>
				<Grid item xs={6}>
					<Grid container alignItems="center" direction="row" spacing={1}>
						<Grid item xs={11}>
							<Select
								fullWidth
								displayEmpty
								variant="outlined"
								value={selectedURLType}
								style={{ height: "52px" }}
								placeholder="Tipo de URL"
								renderValue={() => TEMPLATE_BUTTON_URL_TYPE_OPTIONS_TO_READABLE_OPTION[selectedURLType as URLTypeOption] || "Selecione o tipo de URL"}
								onChange={({ target }) => handleURLTypeChange(target.value as URLTypeOption)}
							>
								<MenuItem value="dynamic">
									URL Dinâmica
								</MenuItem>
								<MenuItem value="static">
									URL Estática
								</MenuItem>
							</Select>
						</Grid>
						<Grid item xs={1}>
							<InputAdornment position="end">
								<IconButton size="small" onClick={() => handleRemoveButtons(index)}>
									<CloseIcon fontSize="small" />
								</IconButton>
							</InputAdornment>
						</Grid>
					</Grid>
				</Grid>

				<Grid item xs={12}>
					<Grid container direction="column" spacing={1}>
						<Grid item>
							<Grid container direction="row" spacing={1} alignItems="center">
								<Grid item>
									<InputLabel style={{ fontWeight: "bold" }}>
										Digite a URL
									</InputLabel>
								</Grid>
								<Grid item>
									<ManageTemplateButtonsFormURLTipsPopover
										urlType={selectedURLType || "static"}
									/>
								</Grid>
							</Grid>
						</Grid>
						<Grid item xs={12}>
							{selectedURLType === "dynamic" ? (
								<Grid container direction="column" spacing={1}>
									<Grid item>
										<TextEditor
											ref={editorRef}
											maxLength={2000}
											onChanged={(value) => {
												handleChangeButtonURL(value, index)
											}}
										/>
										{!!validation?.[`buttons[${index}].url`] && (
											<Grid item>
												<Text.Body
													type="smaller2"
													color={themeColors.getTextErrorColor()}
												>
													{validation[`buttons[${index}].url`]}
												</Text.Body>
											</Grid>
										)}
									</Grid>
									<Grid item>
										<VariableInput
											variables={variables}
											disabled={hasVariable(button.url)}
											onVariable={(variable) => editorRef.current?.addEntityByCursor("VARIABLE", variable)}
										/>
									</Grid>
								</Grid>
							) : (
								<Grid container direction="column">
									<Grid item>
										<TextInput
											defaultValue={button?.url}
											isOutlined
											onMedia={() => ""}
											onSubmit={() => ""}
											onChange={(value) => handleChangeButtonURL(value || "", index)}
											inputProps={{
												maxLength: 2000
											}}
										/>
										{!!validation?.[`buttons[${index}].url`] && (
											<Grid item>
												<Text.Body
													type="smaller2"
													color={themeColors.getTextErrorColor()}
												>
													{validation[`buttons[${index}].url`]}
												</Text.Body>
											</Grid>
										)}
									</Grid>
								</Grid>
							)}
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default ManageTemplateURLButton
